export default {
  layout: {
    title: 'Your cards on File',
    description: 'These are the payment methods stored on your account. Looking for which card you use for billing? {{linkOpen}}Visit your billing settings.{{linkClose}}',
  },
};
